import './App.css';

import React from 'react';

import AppRouter from './components/AppRouter';

function App() {
 return (
   <div className="App">
     <AppRouter />
   </div>
 );
}

export default App;